export default "__VITE_ASSET__CFzy0V4L__"